/* =========================================================================
   Pure n' Bio · Born to Bio Bundle Landing
   bundle-landing.js
   Vanilla JS, no dependencies. Real Shopify cart via /cart/add.js + /cart.js.
   Free-gift threshold: 300 SAR (customer picks one mask).
   ========================================================================= */

(function () {
  'use strict';

  // ------------------------------------------------------------------------
  // CONFIG — pulled from window.PnbBundleConfig (injected by the section).
  // ------------------------------------------------------------------------
  var _CFG = (typeof window !== 'undefined' && window.PnbBundleConfig) || {};
  var THRESHOLD = _CFG.threshold || 300;                // SAR — free gift threshold
  var SHIPPING_THRESHOLD = _CFG.shippingThreshold || 299; // SAR — free shipping
  var GIFT_PROP_KEY = '_gift';
  var GIFT_PROP_VALUE = _CFG.giftPropValue || 'born-to-bio';

  var SAR_ICON = '<span class="pnb-sar" aria-label="SAR"></span>';
  var LOCALE_PREFIX = (/^\/ar(\/|$)/.test(window.location.pathname)) ? '/ar' : '';
  var TABBY_LOGO_SVG = '<svg class="pnb-qv-tabby-logo" viewBox="22 70 168 72" role="img" aria-label="tabby" xmlns="http://www.w3.org/2000/svg" focusable="false"><path fill="#5AFEAE" d="M166.2,139.5H45.8c-11.6,0-20.9-9.4-20.9-20.9V93.5c0-11.6,9.4-20.9,20.9-20.9h120.4c11.6,0,20.9,9.4,20.9,20.9v25.1C187.1,130.1,177.8,139.5,166.2,139.5z"/><path fill="#292929" d="M157.9,94.1l-8.3,31.7l0,0.1h6.5l8.3-31.7H157.9z M55.3,112.1c-1,0.5-2,0.7-3.1,0.7c-2.3,0-3.6-0.4-3.8-2.3v-0.1c0-0.1,0-0.1,0-0.2v-5.5l0-0.6v-3.9h0v-1.6l0-0.6v-3.7L42.6,95c3.9-0.8,6.1-3.8,6.1-6.9v-1.9h-6.5v8.9l-0.4,0.1v16.4c0.2,4.6,3.3,7.4,8.2,7.4c1.8,0,3.7-0.4,5.2-1.1l0,0L55.3,112.1L55.3,112.1L55.3,112.1z M56.3,92.9l-18.2,2.8v4.6l18.2-2.8C56.3,97.5,56.3,92.9,56.3,92.9z M56.3,99.7l-18.2,2.8v4.4l18.2-2.8C56.3,104.1,56.3,99.7,56.3,99.7z M76.7,101.8c-0.3-5.1-3.5-8.2-8.7-8.2c-3,0-5.5,1.2-7.2,3.4c-1.7,2.2-2.6,5.4-2.6,9.3c0,3.9,0.9,7.1,2.6,9.3c1.7,2.2,4.2,3.3,7.2,3.3c5.2,0,8.4-3,8.7-8.2v7.7h6.5V94.2l-6.5,1L76.7,101.8L76.7,101.8z M77.1,106.3c0,4.5-2.4,7.5-6.1,7.5c-3.8,0-6.1-2.8-6.1-7.5c0-4.7,2.3-7.5,6.1-7.5c1.8,0,3.4,0.7,4.5,2.1C76.5,102.2,77.1,104.1,77.1,106.3C77.1,106.3,77.1,106.3,77.1,106.3z M102.1,93.6c-5.2,0-8.4,3-8.7,8.2V87.1l-6.5,1v30.3h6.5v-7.7c0.3,5.2,3.5,8.2,8.7,8.2c6.1,0,9.8-4.7,9.8-12.6S108.2,93.6,102.1,93.6z M99.2,113.8c-3.7,0-6.1-2.9-6.1-7.5c0-2.2,0.6-4.1,1.6-5.4c1.1-1.4,2.6-2.1,4.5-2.1c3.8,0,6.1,2.8,6.1,7.5C105.3,111,103,113.8,99.2,113.8L99.2,113.8z M129.5,93.6c-5.2,0-8.4,3-8.7,8.2V87.1l-6.5,1v30.3h6.5v-7.7c0.3,5.2,3.5,8.2,8.7,8.2c6.1,0,9.8-4.7,9.8-12.6S135.6,93.6,129.5,93.6L129.5,93.6z M126.6,113.8c-3.7,0-6.1-2.9-6.1-7.5c0-2.2,0.6-4.1,1.6-5.4c1.1-1.4,2.6-2.1,4.5-2.1c3.8,0,6.1,2.8,6.1,7.5C132.7,111,130.4,113.8,126.6,113.8L126.6,113.8z M139.3,94.1h6.9l5.6,24.3h-6.2C145.6,118.4,139.3,94.1,139.3,94.1z M169.7,96.6v-1.9h-0.8v-0.4h2.1v0.4h-0.8v1.9H169.7z M171.1,96.6v-2.4h0.8l0.4,1.1c0.1,0.3,0.2,0.4,0.2,0.5c0-0.1,0.1-0.2,0.2-0.5l0.4-1.1h0.8v2.4h-0.5v-1.9l-0.7,1.9h-0.5l-0.6-1.9v1.9L171.1,96.6L171.1,96.6z"/></svg>';
  var URL_KEY = 'pnb_bundle_url';
  var BUNDLE_URL = window.location.pathname;
  var IS_RTL = document.documentElement.dir === 'rtl' || !!document.querySelector('.pnb-bundle.is-rtl');

  // Cached cart state — refreshed from /cart.js on every mutation.
  var STATE = { cart: null, syncing: false };

  // ------------------------------------------------------------------------
  // L10N
  // ------------------------------------------------------------------------
  var L = IS_RTL ? {
    inBundle: 'تمت اضافتها للمجموعة',
    add: 'أضيفي للمجموعة',
    soldout: 'نفذت الكمية',
    onlyLeft: function (n) { return 'تبقى ' + toArDigits(n) + ' فقط'; },
    inStock: 'متوفر',
    toGift: function (n) { return 'يتبقى ' + toArDigits(n) + ' ' + SAR_ICON + ' على هديتُكِ'; },
    unlocked: 'الهدية مُفعّلة',
    shippingTo: function (n) { return 'يتبقى ' + toArDigits(n) + ' ' + SAR_ICON + ' على الشّحن المجاني'; },
    shippingDone: 'الشّحن المجاني مُفعّل',
    bundleX: function (x) { return 'الإجمالي ' + toArDigits(x) + ' ' + SAR_ICON; },
    ofTotal: function (x) { return toArDigits(x) + ' من 300 ' + SAR_ICON; },
    remaining: function (n) { return toArDigits(n) + ' ' + SAR_ICON; },
    backToBundle: 'عودي لمجموعتكِ',
    knowMore: 'اعرفي المزيد ←',
    showAll: 'عرض جميع المنتجات',
    showLess: 'عرض أقل',
    faqShowMore: 'عرض المزيد من الأسئلة',
    faqShowLess: 'عرض أقل',
  } : {
    inBundle: 'In bundle',
    add: 'Add to bundle',
    soldout: 'Sold out',
    onlyLeft: function (n) { return 'Only ' + n + ' left'; },
    inStock: 'In stock',
    toGift: function (n) { return n + ' ' + SAR_ICON + ' to your free mask'; },
    unlocked: 'Free mask unlocked',
    shippingTo: function (n) { return n + ' ' + SAR_ICON + ' to free shipping'; },
    shippingDone: 'Free shipping unlocked',
    bundleX: function (x) { return 'Bundle ' + x + ' ' + SAR_ICON; },
    ofTotal: function (x) { return x + ' of 300 ' + SAR_ICON; },
    remaining: function (n) { return n + ' ' + SAR_ICON; },
    showAll: 'Show all products',
    showLess: 'Show less',
    faqShowMore: 'Show more questions',
    faqShowLess: 'Show fewer questions',
    backToBundle: 'Back to your bundle',
    knowMore: 'Know more →',
  };

  (function applyConfigLabels() {
    var lbl = _CFG && _CFG.labels;
    if (!lbl || typeof lbl !== 'object') return;
    function fmt(tpl) { return function (n) { return String(tpl).replace('%AMOUNT%', toArDigits(n)); }; }
    if (lbl.toGift) L.toGift = fmt(lbl.toGift);
    if (lbl.toShipping) L.shippingTo = fmt(lbl.toShipping);
    if (lbl.shippingDone) L.shippingDone = lbl.shippingDone;
    if (lbl.unlocked) L.unlocked = lbl.unlocked;
    if (lbl.inBundle) L.inBundle = lbl.inBundle;
    if (lbl.add) L.add = lbl.add;
    if (lbl.soldout) L.soldout = lbl.soldout;
    if (lbl.backToBundle) L.backToBundle = lbl.backToBundle;
  })();

  function toArDigits(n) {
    if (!IS_RTL) return n;
    var map = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return String(n).replace(/[0-9]/g, function (d) { return map[parseInt(d, 10)]; });
  }

  // ------------------------------------------------------------------------
  // CART STATE — real Shopify cart via /cart.js + /cart/add.js + /cart/change.js
  // ------------------------------------------------------------------------
  function cartFetch() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (c) { STATE.cart = c; return c; });
  }

  function notifyThemeCartChanged() {
    // Tell the theme's cart-drawer + cart-bubble to re-fetch from /cart.js.
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: STATE.cart } }));
    } catch (e) { /* old browsers */ }
  }

  function cartAdd(items) {
    var arr = Array.isArray(items) ? items : [items];
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: arr })
    }).then(function (r) {
      if (r.ok) return r.json();
      return r.json().then(function (j) { return Promise.reject(j); }, function () { return Promise.reject(r.status); });
    }).then(function (data) { notifyThemeCartChanged(); return data; });
  }

  function cartChange(payload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) { STATE.cart = data; notifyThemeCartChanged(); return data; });
  }

  function cartTotalSar() {
    var c = STATE.cart;
    if (!c) return 0;
    return Math.round((c.total_price || 0) / 100);
  }

  // True when the variant has a non-gift line in the cart. A gift line is
  // marked with properties[_gift]=born-to-bio and shouldn't toggle the "in
  // bundle" UI on the matching mask card.
  function inCart(variantId) {
    var c = STATE.cart;
    if (!c || !c.items) return false;
    var v = String(variantId);
    return c.items.some(function (it) {
      if (String(it.variant_id) !== v) return false;
      var p = it.properties || {};
      return p[GIFT_PROP_KEY] !== GIFT_PROP_VALUE;
    });
  }

  function findCartLineKeyByVariant(variantId) {
    var c = STATE.cart;
    if (!c || !c.items) return null;
    var v = String(variantId);
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      if (String(it.variant_id) !== v) continue;
      var p = it.properties || {};
      if (p[GIFT_PROP_KEY] === GIFT_PROP_VALUE) continue;
      return it.key;
    }
    return null;
  }

  function findGiftLineKey() {
    var c = STATE.cart;
    if (!c || !c.items) return null;
    for (var i = 0; i < c.items.length; i++) {
      var p = c.items[i].properties || {};
      if (p[GIFT_PROP_KEY] === GIFT_PROP_VALUE) return c.items[i].key;
    }
    return null;
  }

  function getPickedGiftVariantId() {
    var checked = document.querySelector('.pnb-gift-radio:checked');
    if (!checked || checked.disabled) return null;
    var v = checked.value;
    return v ? Number(v) : null;
  }

  // Reconcile gift line item with current cart total + selected radio.
  // Always re-fetches /cart.js first so the decision uses live state.
  function syncGiftItem() {
    if (STATE.syncing) return Promise.resolve();
    STATE.syncing = true;
    var done = function () { STATE.syncing = false; };

    return cartFetch().then(function () {
      var total = cartTotalSar();
      var existingKey = findGiftLineKey();
      var targetVariant = (total >= THRESHOLD) ? getPickedGiftVariantId() : null;

      if (existingKey && targetVariant) {
        var existing = STATE.cart.items.find(function (it) { return it.key === existingKey; });
        if (existing && existing.variant_id === targetVariant) return null;
      }

      var p = Promise.resolve();
      if (existingKey) {
        p = p.then(function () { return cartChange({ id: existingKey, quantity: 0 }); });
      }
      if (targetVariant) {
        p = p.then(function () {
          var item = { id: targetVariant, quantity: 1, properties: {} };
          item.properties[GIFT_PROP_KEY] = GIFT_PROP_VALUE;
          return cartAdd(item);
        }).then(function () { return cartFetch(); });
      }
      return p;
    }).then(function () { renderState(); done(); }).catch(function () { done(); });
  }

  function rememberBundleUrl() {
    try { sessionStorage.setItem(URL_KEY, BUNDLE_URL); } catch (e) { /* ignore */ }
  }

  // Mark this bundle as the active "back-to-bundle" target. Read by the
  // pnb_born_* injection block in layout/theme.liquid on subsequent product
  // page navigations. Cleared by user dismissal (pnb_born_btb_dismissed='1').
  function rememberBornBundleActive() {
    try {
      sessionStorage.setItem('pnb_born_bundle_active', '1');
      sessionStorage.setItem('pnb_born_bundle_path', BUNDLE_URL);
      sessionStorage.removeItem('pnb_born_btb_dismissed');
    } catch (e) { /* ignore */ }
  }

  // ------------------------------------------------------------------------
  // RENDER — sync UI to current cart state
  // ------------------------------------------------------------------------
  function renderState() {
    var total = cartTotalSar();
    var shipPct = Math.min(100, (total / SHIPPING_THRESHOLD) * 100);
    var giftPct = Math.min(100, (total / THRESHOLD) * 100);
    var shipRemain = Math.max(0, SHIPPING_THRESHOLD - total);
    var giftRemain = Math.max(0, THRESHOLD - total);
    var shipUnlocked = total >= SHIPPING_THRESHOLD;
    var giftUnlocked = total >= THRESHOLD;

    var totalEl = document.getElementById('pnb-rewards-total');
    var shipFillEl = document.getElementById('pnb-reward-shipping-fill');
    var shipTextEl = document.getElementById('pnb-reward-shipping-text');
    var giftFillEl = document.getElementById('pnb-reward-gift-fill');
    var giftTextEl = document.getElementById('pnb-reward-gift-text');
    var shipRow = shipFillEl ? shipFillEl.closest('.pnb-reward-row') : null;
    var giftRow = giftFillEl ? giftFillEl.closest('.pnb-reward-row') : null;

    var rewardSection = document.getElementById('pnb-reward');
    var rewardOverlay = document.getElementById('pnb-reward-overlay');
    var remainingEl = document.getElementById('pnb-remaining');

    if (totalEl) totalEl.innerHTML = toArDigits(total) + ' ' + SAR_ICON;
    if (shipFillEl) shipFillEl.style.width = shipPct + '%';
    if (giftFillEl) giftFillEl.style.width = giftPct + '%';
    if (shipRow) shipRow.classList[shipUnlocked ? 'add' : 'remove']('is-unlocked');
    if (giftRow) giftRow.classList[giftUnlocked ? 'add' : 'remove']('is-unlocked');
    if (shipTextEl) shipTextEl.innerHTML = shipUnlocked ? L.shippingDone : L.shippingTo(shipRemain);
    if (giftTextEl) giftTextEl.innerHTML = giftUnlocked ? L.unlocked : L.toGift(giftRemain);

    if (giftRemain > 0) {
      if (remainingEl) remainingEl.innerHTML = L.remaining(giftRemain);
      if (rewardSection) rewardSection.classList.add('is-locked');
      if (rewardOverlay) rewardOverlay.style.display = 'flex';
    } else {
      if (rewardSection) rewardSection.classList.remove('is-locked');
      if (rewardOverlay) rewardOverlay.style.display = 'none';
    }

    // Sync product cards (skip gift radios — they live outside .pnb-card/.pnb-best-item)
    document.querySelectorAll('.pnb-card [data-variant-id], .pnb-best-item [data-variant-id], .pnb-card[data-variant-id], .pnb-best-item[data-variant-id]').forEach(function (el) {
      var vid = el.getAttribute('data-variant-id');
      var card = el.closest('.pnb-card, .pnb-best-item');
      var btn = el.matches('.pnb-btn-add') ? el : (card ? card.querySelector('.pnb-btn-add') : null);

      if (inCart(vid)) {
        if (card) card.classList.add('is-added');
        if (btn) {
          btn.classList.add('is-added');
          btn.textContent = L.inBundle;
        }
      } else {
        if (card) card.classList.remove('is-added');
        if (btn) {
          btn.classList.remove('is-added');
          btn.textContent = L.add;
        }
      }
    });
  }

  function flashAdded(btn, errored) {
    var orig = btn.dataset.origLabel || btn.textContent;
    btn.dataset.origLabel = orig;
    btn.textContent = errored
      ? (IS_RTL ? '⚠ غير متاح' : '⚠ Unavailable')
      : (IS_RTL ? '✓ أُضيف' : '✓ Added');
    setTimeout(function () { /* renderState re-paints; only restore if still in this transient state */
      if (btn.textContent.indexOf('✓') === 0 || btn.textContent.indexOf('⚠') === 0) {
        btn.textContent = orig;
      }
    }, 1400);
  }

  // ------------------------------------------------------------------------
  // PRODUCT INTERACTIONS — REAL CART
  // ------------------------------------------------------------------------
  function handleCardClick(e) {
    var card = e.target.closest('.pnb-card');
    if (!card) return;
    if (e.target.matches('.pnb-btn-add')) return; // let button handler take it
    var handle = card.getAttribute('data-handle');
    if (handle) openQuickView(handle);
  }

  function handleBestsellerClick(e) {
    var item = e.target.closest('.pnb-best-item');
    if (!item) return;
    if (e.target.matches('.pnb-btn-add')) return;
    var handle = item.getAttribute('data-handle');
    if (handle) openQuickView(handle);
  }

  function handleAddClick(e) {
    var btn = e.target.closest('.pnb-btn-add');
    if (!btn) return;
    if (btn.closest('.pnb-modal')) return; // quick-view modal has its own handler

    e.stopPropagation();
    e.preventDefault();
    if (btn.disabled) return;

    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    var hasVariants = btn.getAttribute('data-has-variants') === 'true';

    // If product has multiple variants, open quick-view to pick one
    if (hasVariants && !inCart(vid)) {
      var handle = btn.getAttribute('data-handle');
      openQuickView(handle);
      return;
    }

    btn.disabled = true;

    if (inCart(vid)) {
      var key = findCartLineKeyByVariant(vid);
      if (!key) { btn.disabled = false; return; }
      cartChange({ id: key, quantity: 0 })
        .then(function () { return syncGiftItem(); })
        .then(function () { renderState(); })
        .catch(function () { /* keep state */ })
        .then(function () { btn.disabled = false; });
      return;
    }

    cartAdd({ id: Number(vid), quantity: 1 })
      .then(function () { return cartFetch(); })
      .then(function () { rememberBundleUrl(); return syncGiftItem(); })
      .then(function () { renderState(); flashAdded(btn, false); })
      .catch(function () { flashAdded(btn, true); })
      .then(function () { btn.disabled = false; });
  }

  // ------------------------------------------------------------------------
  // QUICK-VIEW POPUP
  // ------------------------------------------------------------------------
  var qvCurrentSlide = 0;
  var qvSlideCount = 0;
  var qvSelectedOptions = {};
  var qvProductData = null;

  var _qvCache = {};

  function _adaptShopifyProduct(sp) {
    return {
      handle: sp.handle,
      title: sp.title,
      brand: sp.vendor,
      description: (sp.description || '').replace(/<[^>]*>/g, '').slice(0, 600),
      images: (sp.images || []).slice(0, 8),
      options: (sp.options || []).map(function (o) {
        if (typeof o === 'string') return { name: o, values: [] };
        return { name: o.name, values: o.values || [] };
      }),
      variants: (sp.variants || []).map(function (v) {
        return {
          id: v.id,
          title: v.title,
          price: Math.round((v.price || 0) / 100),
          available: !!v.available,
          inventoryQuantity: null,
          options: [v.option1, v.option2, v.option3].filter(function (x) { return x != null; })
        };
      })
    };
  }

  function openQuickView(handle) {
    var modal = document.getElementById('pnb-qv-modal');
    if (!modal) return;

    function _mount(data) {
      qvProductData = data;
      qvCurrentSlide = 0;
      qvSelectedOptions = {};
      if (qvProductData.options) {
        qvProductData.options.forEach(function (opt) {
          qvSelectedOptions[opt.name] = opt.values[0];
        });
      }
      renderQuickView();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    var dataEl = document.querySelector('[data-pnb-product="' + handle + '"]');
    if (dataEl) {
      try {
        _mount(JSON.parse(dataEl.textContent));
        return;
      } catch (e) { /* fall through to fetch */ }
    }

    if (_qvCache[handle]) {
      _mount(_qvCache[handle]);
      return;
    }

    var grid = document.getElementById('pnb-product-grid');
    var root = (grid && grid.getAttribute('data-routes-root')) || '/';
    if (root.slice(-1) !== '/') root += '/';
    var url = root + 'products/' + encodeURIComponent(handle) + '.js';

    modal.classList.add('is-loading');
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (sp) {
        var adapted = _adaptShopifyProduct(sp);
        _qvCache[handle] = adapted;
        modal.classList.remove('is-loading');
        _mount(adapted);
      })
      .catch(function (err) {
        console.error('Quick-view fetch failed for', handle, err);
        modal.classList.remove('is-loading');
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
  }

  function closeQuickView() {
    var modal = document.getElementById('pnb-qv-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    qvProductData = null;
  }

  function renderQuickView() {
    if (!qvProductData) return;
    var p = qvProductData;
    var current = currentVariant();

    var trackEl = document.getElementById('pnb-qv-track');
    var dotsEl = document.getElementById('pnb-qv-dots');
    if (trackEl && p.images && p.images.length) {
      qvSlideCount = p.images.length;
      trackEl.innerHTML = p.images.map(function (src) {
        return '<div class="pnb-qv-slide"><img src="' + escapeHtml(src) + '" alt="' + escapeHtml(p.title || '') + '" loading="lazy"></div>';
      }).join('');
      trackEl.style.transform = 'translateX(' + (IS_RTL ? '' : '-') + (qvCurrentSlide * 100) + '%)';
      if (IS_RTL) trackEl.style.transform = 'translateX(' + (qvCurrentSlide * 100) + '%)';
    }
    if (dotsEl && qvSlideCount > 1) {
      dotsEl.innerHTML = '';
      for (var i = 0; i < qvSlideCount; i++) {
        var dot = document.createElement('div');
        dot.className = 'pnb-qv-dot' + (i === qvCurrentSlide ? ' is-active' : '');
        dot.setAttribute('data-slide', i);
        dotsEl.appendChild(dot);
      }
    } else if (dotsEl) {
      dotsEl.innerHTML = '';
    }

    var brandEl = document.getElementById('pnb-qv-brand');
    var titleEl = document.getElementById('pnb-qv-title');
    var priceEl = document.getElementById('pnb-qv-price');
    var stockEl = document.getElementById('pnb-qv-stock');
    var descEl = document.getElementById('pnb-qv-desc');
    var optionsEl = document.getElementById('pnb-qv-options');
    var addBtn = document.getElementById('pnb-qv-add');

    if (brandEl) brandEl.textContent = p.brand || '';
    if (titleEl) titleEl.textContent = p.title || '';
    if (priceEl && current) priceEl.innerHTML = toArDigits(current.price) + ' ' + SAR_ICON;

    var tabbyEl = document.getElementById('pnb-qv-tabby');
    if (!tabbyEl) {
      // Inject lazily if the snippet on the cached page doesn't have it yet.
      var priceEl = document.getElementById('pnb-qv-price');
      if (priceEl && priceEl.parentNode) {
        tabbyEl = document.createElement('div');
        tabbyEl.id = 'pnb-qv-tabby';
        tabbyEl.className = 'pnb-qv-tabby';
        tabbyEl.hidden = true;
        priceEl.parentNode.insertBefore(tabbyEl, priceEl.nextSibling);
      }
    }
    if (tabbyEl) {
      if (current && current.available && current.price > 0) {
        var amt = Math.ceil(current.price / 4);
        var amtStr = toArDigits(amt);
        var textHtml = IS_RTL
          ? '<span class="pnb-qv-tabby-text">٤ × <b>' + amtStr + '</b> ' + SAR_ICON + '</span>'
          : '<span class="pnb-qv-tabby-text">4 × <b>' + amtStr + '</b> ' + SAR_ICON + '</span>';
        tabbyEl.innerHTML = IS_RTL ? (textHtml + TABBY_LOGO_SVG) : (TABBY_LOGO_SVG + textHtml);
        tabbyEl.hidden = false;
      } else {
        tabbyEl.hidden = true;
        tabbyEl.textContent = '';
      }
    }
    if (descEl) descEl.textContent = p.description || '';

    if (stockEl && current) {
      stockEl.className = 'pnb-qv-stock';
      if (!current.available) {
        stockEl.classList.add('is-out');
        stockEl.textContent = L.soldout;
      } else if (current.inventoryQuantity !== null && current.inventoryQuantity <= 5 && current.inventoryQuantity > 0) {
        stockEl.classList.add('is-low');
        stockEl.textContent = L.onlyLeft(current.inventoryQuantity);
      } else {
        stockEl.classList.add('is-instock');
        stockEl.textContent = L.inStock;
      }
    }

    if (optionsEl) {
      if (!p.options || !p.options.length || (p.options.length === 1 && p.options[0].values.length === 1)) {
        optionsEl.innerHTML = '';
      } else {
        optionsEl.innerHTML = p.options.map(function (opt) {
          var safeName = escapeHtml(opt.name);
          var rows = opt.values.map(function (val) {
            var testOpts = Object.assign({}, qvSelectedOptions);
            testOpts[opt.name] = val;
            var matchVar = findVariant(testOpts);
            var soldout = !matchVar || !matchVar.available;
            var selected = qvSelectedOptions[opt.name] === val;
            var safeVal = escapeHtml(val);
            return '<button class="pnb-qv-variant' +
              (selected ? ' is-selected' : '') +
              (soldout ? ' is-soldout' : '') +
              '" data-option="' + safeName + '" data-value="' + safeVal + '"' +
              (soldout ? ' disabled' : '') + ' type="button">' + safeVal + '</button>';
          }).join('');
          return '<div class="pnb-qv-option">' +
            '<span class="pnb-qv-option-label">' + safeName + '</span>' +
            '<div class="pnb-qv-option-row">' + rows + '</div></div>';
        }).join('');
      }
    }

    if (addBtn && current) {
      addBtn.setAttribute('data-variant-id', current.id);
      if (!current.available) {
        addBtn.disabled = true;
        addBtn.textContent = L.soldout;
      } else if (inCart(current.id)) {
        addBtn.disabled = false;
        addBtn.textContent = L.inBundle;
      } else {
        addBtn.disabled = false;
        addBtn.textContent = L.add;
      }
    }

    // "Know more →" secondary link to the actual product page (locale-prefixed).
    var moreEl = document.getElementById('pnb-qv-more');
    if (!moreEl && addBtn && addBtn.parentNode) {
      moreEl = document.createElement('a');
      moreEl.id = 'pnb-qv-more';
      moreEl.className = 'pnb-qv-more';
      // Same-tab navigation so sessionStorage persists for the back-to-bundle tab on the product page.
      moreEl.style.cssText = 'display:block;text-align:center;margin-top:14px;font-size:13px;font-weight:500;letter-spacing:.05em;color:#6b6049;text-decoration:underline;text-underline-offset:3px;font-family:inherit';
      addBtn.parentNode.insertBefore(moreEl, addBtn.nextSibling);
    }
    if (moreEl && p && p.handle) {
      moreEl.href = LOCALE_PREFIX + '/products/' + encodeURIComponent(p.handle);
      moreEl.textContent = L.knowMore;
    }
  }

  function currentVariant() {
    if (!qvProductData) return null;
    return findVariant(qvSelectedOptions);
  }

  function findVariant(opts) {
    if (!qvProductData || !qvProductData.variants) return null;
    return qvProductData.variants.find(function (v) {
      return v.options.every(function (o, i) {
        return o === opts[qvProductData.options[i].name];
      });
    }) || qvProductData.variants[0];
  }

  function handleQVClick(e) {
    if (e.target.matches('.pnb-modal-close, .pnb-modal-backdrop')) {
      if (e.target.matches('.pnb-modal-backdrop') && !e.target.id) return;
      closeQuickView();
      return;
    }
    if (e.target.matches('.pnb-qv-arrow.is-prev')) {
      qvCurrentSlide = (qvCurrentSlide - 1 + qvSlideCount) % qvSlideCount;
      renderQuickView();
      return;
    }
    if (e.target.matches('.pnb-qv-arrow.is-next')) {
      qvCurrentSlide = (qvCurrentSlide + 1) % qvSlideCount;
      renderQuickView();
      return;
    }
    if (e.target.matches('.pnb-qv-dot')) {
      qvCurrentSlide = parseInt(e.target.getAttribute('data-slide'), 10);
      renderQuickView();
      return;
    }
    if (e.target.matches('.pnb-qv-variant') && !e.target.disabled) {
      var name = e.target.getAttribute('data-option');
      var val = e.target.getAttribute('data-value');
      qvSelectedOptions[name] = val;
      renderQuickView();
      return;
    }
    if (e.target.matches('#pnb-qv-add')) {
      handleQvAdd(e.target);
    }
  }

  function handleQvAdd(btn) {
    var v = currentVariant();
    if (!v || !v.available || btn.disabled) return;
    btn.disabled = true;

    if (inCart(v.id)) {
      var key = findCartLineKeyByVariant(v.id);
      if (!key) { btn.disabled = false; return; }
      cartChange({ id: key, quantity: 0 })
        .then(function () { return syncGiftItem(); })
        .then(function () { renderState(); renderQuickView(); })
        .catch(function () { /* keep state */ })
        .then(function () { btn.disabled = false; });
      return;
    }

    cartAdd({ id: Number(v.id), quantity: 1 })
      .then(function () { return cartFetch(); })
      .then(function () { rememberBundleUrl(); return syncGiftItem(); })
      .then(function () {
        renderState();
        renderQuickView();
        // Auto-close the modal a moment after a successful add
        setTimeout(closeQuickView, 700);
      })
      .catch(function () {
        btn.textContent = IS_RTL ? '⚠ تعذّر الإضافة' : '⚠ Could not add';
      })
      .then(function () { btn.disabled = false; });
  }

  function escapeHtml(s) {
    if (!s) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ------------------------------------------------------------------------
  // GIFT PICKER — customer chooses one mask once 300 SAR threshold is met.
  // Selection drives a real cart line item with properties[_gift]=born-to-bio.
  // ------------------------------------------------------------------------
  function handleGiftOptionClick(e) {
    var option = e.target.closest('.pnb-gift-option');
    if (!option || option.classList.contains('is-soldout')) return;
    var radio = option.querySelector('.pnb-gift-radio');
    if (!radio || radio.disabled) return;
    radio.checked = true;
    document.querySelectorAll('.pnb-gift-option').forEach(function (o) { o.classList.remove('is-selected'); });
    option.classList.add('is-selected');
    syncGiftItem();
  }

  function ensureGiftSelection() {
    var checked = document.querySelector('.pnb-gift-radio:checked');
    if (checked && !checked.disabled) return;
    var firstOk = document.querySelector('.pnb-gift-radio:not([disabled])');
    if (!firstOk) return;
    firstOk.checked = true;
    var opt = firstOk.closest('.pnb-gift-option');
    document.querySelectorAll('.pnb-gift-option').forEach(function (o) { o.classList.remove('is-selected'); });
    if (opt) opt.classList.add('is-selected');
  }

  // ------------------------------------------------------------------------
  // FILTER CHIPS + 5-ROW LIMIT (build-your-bundle grid)
  // ------------------------------------------------------------------------
  var GRID_LIMIT_ROWS = 5;

  function _gridColumns(grid) {
    try {
      var tpl = getComputedStyle(grid).getPropertyValue('grid-template-columns');
      var n = tpl.split(' ').filter(function (x) { return x.trim(); }).length;
      return n > 0 ? n : 2;
    } catch (e) { return 2; }
  }

  function applyGridLimit() {
    var grid = document.getElementById('pnb-product-grid');
    if (!grid) return;
    var active = document.querySelector('.pnb-chip.is-active');
    var filter = active ? active.getAttribute('data-filter') : 'all';
    var isCollapsed = grid.classList.contains('is-collapsed');
    var limit = _gridColumns(grid) * GRID_LIMIT_ROWS;

    var matchingTotal = 0;
    var cards = grid.querySelectorAll('.pnb-card');
    cards.forEach(function (card) {
      var cats = (card.getAttribute('data-cats') || '').split(',');
      var match = filter === 'all' || cats.indexOf(filter) !== -1;
      if (match) matchingTotal++;
    });

    var shown = 0;
    cards.forEach(function (card) {
      var cats = (card.getAttribute('data-cats') || '').split(',');
      var match = filter === 'all' || cats.indexOf(filter) !== -1;
      if (!match) { card.style.display = 'none'; return; }
      if (filter === 'all' && isCollapsed && shown >= limit) {
        card.style.display = 'none';
        return;
      }
      card.style.display = 'flex';
      shown++;
    });

    var wrap = document.getElementById('pnb-grid-more-wrap');
    var btn = document.getElementById('pnb-grid-more');
    var countEl = document.getElementById('pnb-grid-more-count');
    var labelEl = document.getElementById('pnb-grid-more-label');
    var shouldShow = filter === 'all' && matchingTotal > limit;
    if (wrap) wrap.style.display = shouldShow ? 'flex' : 'none';
    if (btn) btn.setAttribute('aria-expanded', String(!isCollapsed));
    if (countEl) countEl.textContent = shouldShow && isCollapsed ? '(' + matchingTotal + ')' : '';
    if (labelEl) labelEl.textContent = isCollapsed ? L.showAll : L.showLess;
    if (filter === 'all' && isCollapsed && matchingTotal > limit) grid.classList.add('has-fade');
    else grid.classList.remove('has-fade');
  }

  function handleChipClick(e) {
    var chip = e.target.closest('.pnb-chip');
    if (!chip) return;
    var chips = chip.parentElement.querySelectorAll('.pnb-chip');
    chips.forEach(function (c) { c.classList.remove('is-active'); });
    chip.classList.add('is-active');
    applyGridLimit();
  }

  function handleGridMoreClick() {
    var grid = document.getElementById('pnb-product-grid');
    if (!grid) return;
    grid.classList.toggle('is-collapsed');
    applyGridLimit();
    if (!grid.classList.contains('is-collapsed')) {
      var cards = grid.querySelectorAll('.pnb-card');
      var limit = _gridColumns(grid) * GRID_LIMIT_ROWS;
      if (cards[limit]) cards[limit].scrollIntoView({ behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    } else {
      grid.scrollIntoView({ behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
  }

  // ------------------------------------------------------------------------
  // FAQ ACCORDION
  // ------------------------------------------------------------------------
  function handleFaqClick(e) {
    if (e.target.closest('#pnb-faq-more')) {
      var btn = document.getElementById('pnb-faq-more');
      var extra = document.getElementById('pnb-faq-extra');
      var label = document.getElementById('pnb-faq-more-label');
      if (!btn || !extra) return;
      var isOpen = extra.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
      if (label) label.textContent = isOpen ? L.faqShowLess : L.faqShowMore;
      return;
    }
    var item = e.target.closest('.pnb-faq-item');
    if (!item) return;
    item.classList.toggle('is-open');
  }

  // ------------------------------------------------------------------------
  // BACK-TO-BUNDLE STICKY PILL (across-site navigation)
  // ------------------------------------------------------------------------
  function maybeShowBackPill() {
    var pill = document.getElementById('pnb-back-pill');
    if (!pill) return;
    if (document.querySelector('.pnb-bundle')) return;
    var savedUrl = sessionStorage.getItem(URL_KEY);
    if (!savedUrl || window.location.pathname === savedUrl) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.item_count) return;
        pill.href = savedUrl;
        var countEl = pill.querySelector('.pnb-count');
        if (countEl) countEl.textContent = c.item_count;
        pill.classList.add('is-visible');
      })
      .catch(function () { /* silent */ });
  }

  // ------------------------------------------------------------------------
  // AJAX LOAD — fetch products beyond Shopify's 50-product Liquid cap
  // ------------------------------------------------------------------------
  var _ajaxStarted = false;
  var _ajaxPage = 2;
  var _ajaxLimit = 50;

  function _escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function _resizeShopifyImage(url, w) {
    if (!url) return '';
    return url.replace(/\.(jpg|jpeg|png|gif|webp)(\?|$)/i, '_' + w + 'x.$1$2');
  }

  function _deriveCats(product) {
    var handle = (product && product.handle ? product.handle : '').toLowerCase();
    var pt = (product && product.product_type ? product.product_type : '').toLowerCase();
    var title = (product && product.title ? product.title : '').toLowerCase();
    var src = (handle + ' | ' + pt + ' | ' + title).replace(/-/g, ' ');
    var has = function (kws) { for (var i = 0; i < kws.length; i++) { if (src.indexOf(kws[i]) !== -1) return true; } return false; };

    var isBaby = src.indexOf('baby') !== -1 || src.indexOf('للأطفال') !== -1 || src.indexOf('بيبي') !== -1;
    var isFaceScrub = has(['face scrub', 'face peeling', 'peeling face', 'scrub face', 'مقشر للوجه', 'مقشر وجه']);
    var isScrub = has(['scrub', 'peeling', 'مقشر']);
    var isLipProduct = has(['lipstick', 'lip balm', 'lip gloss', 'شفاه', 'روج']);
    var isMultiOil = false;
    if (src.indexOf('cleansing') === -1 && src.indexOf('essential oil') === -1 && src.indexOf('منظف') === -1 && !isLipProduct) {
      if (has(['dry oil', 'almond oil', 'argan oil', 'monoï oil', 'monoi oil', 'coconut oil', 'jojoba oil', 'sublime oil', 'body oil', 'care oil', 'زيت جاف', 'زيت عناية'])) isMultiOil = true;
    }
    var isBodyItem = has(['body', 'shower', 'جسم', 'دش', 'استحمام']);

    var c = '';
    if (has(['eye pencil', 'eyeliner', 'eyebrow', 'eye shadow', 'eye mask', 'eye patch', 'eye serum', 'eye cream', 'eye contour', 'mascara', 'عيون', 'عين', 'حاجب', 'ظلال', 'كحل', 'ماسكارا'])) c += 'eyes,';
    if (has(['lipstick', 'lip balm', 'lip gloss', 'lip liner', 'شفاه', 'روج', 'احمر شفاه', 'أحمر شفاه'])) c += 'lips,';
    if (!isBaby && has(['remover', 'cleansing', 'cleanser', 'micellar', 'مزيل مكياج', 'ميسيلار', 'منظف للوجه'])) c += 'makeup-remover,';
    if (has(['shampoo', 'conditioner', 'hair mask', 'castor', 'hair care', 'شامبو', 'بلسم', 'شعر']) || isMultiOil) c += 'hair,';

    var matchBody = has(['shower', 'body', 'deodorant', 'monoï', 'monoi', 'intimate', 'hand wash', 'hand cream', 'جسم', 'دش', 'مزيل عرق', 'استحمام', 'حميم']);
    if (isScrub && !isFaceScrub) matchBody = true;
    if (isMultiOil) matchBody = true;
    if (matchBody) c += 'body,';

    var matchFace = has(['foundation', 'bb cream', 'powder', 'blush', 'highlighter', 'concealer', 'primer', 'contour', 'bronzing', 'face mask', 'face cleansing', 'face care', 'face cream', 'makeup base', 'make up base', 'make-up base', 'cotton mask', 'illuminating mask', 'purity mask', 'detox mask', 'كريم أساس', 'بودرة', 'أحمر خدود', 'بي بي', 'كونسيلر', 'برايمر', 'قناع وجه', 'ماسك وجه', 'قناع للوجه', 'ماسك للوجه']);
    if (isFaceScrub) matchFace = true;
    if (isMultiOil) matchFace = true;
    if (matchFace) c += 'face,';

    var matchSkin = has(['moisturizer', 'serum', 'anti-aging', 'anti aging', 'anging', 'toner', 'toning lotion', 'day cream', 'night cream', 'anti-pollution', 'face cream', 'face mask', 'face care', 'aloe vera', 'radiance', 'cotton mask', 'illuminating mask', 'purity mask', 'detox mask', 'سيروم', 'مرطب', 'تونر', 'مضاد للتجاعيد', 'بشرة']);
    if (isFaceScrub) matchSkin = true;
    if (isMultiOil) matchSkin = true;
    if (isBodyItem && !isMultiOil && !isFaceScrub) matchSkin = false;
    if (matchSkin) c += 'skin-care,';

    return c;
  }

  function _appendAjaxCard(p) {
    var grid = document.getElementById('pnb-product-grid');
    if (!grid) return;
    if (grid.querySelector('[data-handle="' + p.handle + '"]')) return;

    var variants = p.variants || [];
    var firstAvail = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) { firstAvail = variants[i]; break; }
    }
    var v = firstAvail || variants[0] || {};
    var available = !!v.available;
    var hasVariants = variants.length > 1;
    var price = Math.round(parseFloat(v.price || '0'));
    var firstImg = (p.images || [])[0];
    var imgSrc = firstImg ? _resizeShopifyImage(firstImg.src, 400) : '';
    var cats = _deriveCats(p);
    var btnLabel = available ? L.add : L.soldout;

    var card = document.createElement('article');
    card.className = 'pnb-card' + (available ? '' : ' is-soldout');
    card.setAttribute('data-handle', p.handle);
    card.setAttribute('data-cats', cats);
    var tabbyHtml = '';
    if (price > 0) {
      var tabbySplit = Math.ceil(price / 4);
      tabbyHtml =
        '<div class="pnb-card-tabby">' + TABBY_LOGO_SVG +
          '<span class="pnb-card-tabby-text">4 × <b>' + tabbySplit + '</b>' + SAR_ICON + '</span>' +
        '</div>';
    }

    card.innerHTML =
      '<span class="pnb-card-badge pnb-card-badge--added">' + _escapeHtml(L.inBundle) + '</span>' +
      '<span class="pnb-card-badge pnb-card-badge--soldout">' + _escapeHtml(L.soldout) + '</span>' +
      '<div class="pnb-card-visual">' +
        (imgSrc ? '<img src="' + _escapeHtml(imgSrc) + '" alt="' + _escapeHtml(p.title) + '" loading="lazy">' : '') +
      '</div>' +
      '<div class="pnb-card-info">' +
        '<h4>' + _escapeHtml(p.title) + '</h4>' +
        (p.product_type && !IS_RTL ? '<div class="pnb-cat">' + _escapeHtml(p.product_type) + '</div>' : '') +
        '<div class="pnb-card-row">' +
          '<span class="pnb-price">' + price + SAR_ICON + '</span>' +
          '<button class="pnb-btn-add"' +
            ' data-variant-id="' + _escapeHtml(v.id) + '"' +
            ' data-handle="' + _escapeHtml(p.handle) + '"' +
            ' data-title="' + _escapeHtml(p.title) + '"' +
            ' data-variant-title="' + _escapeHtml(v.title || '') + '"' +
            ' data-price="' + price + '"' +
            ' data-image="' + _escapeHtml(firstImg ? _resizeShopifyImage(firstImg.src, 200) : '') + '"' +
            ' data-has-variants="' + hasVariants + '"' +
            (available ? '' : ' disabled') + '>' + _escapeHtml(btnLabel) + '</button>' +
        '</div>' +
        tabbyHtml +
      '</div>';

    var options = (p.options || []).map(function (o, idx) {
      var name = typeof o === 'string' ? o : (o.name || ('Option ' + (idx + 1)));
      var seen = {};
      variants.forEach(function (vv) {
        var val = vv['option' + (idx + 1)];
        if (val != null) seen[val] = true;
      });
      return { name: name, values: Object.keys(seen) };
    });
    var jsonData = {
      handle: p.handle,
      title: p.title,
      brand: p.vendor || '',
      description: (p.body_html || '').replace(/<[^>]+>/g, '').substring(0, 600),
      images: (p.images || []).map(function (i) { return _resizeShopifyImage(i.src, 800); }),
      options: options,
      variants: variants.map(function (vv) {
        return {
          id: vv.id,
          title: vv.title,
          price: Math.round(parseFloat(vv.price || '0')),
          available: !!vv.available,
          inventoryQuantity: null,
          options: [vv.option1, vv.option2, vv.option3].filter(function (x) { return x != null; })
        };
      })
    };

    var jsonScript = document.createElement('script');
    jsonScript.type = 'application/json';
    jsonScript.setAttribute('data-pnb-product', p.handle);
    jsonScript.textContent = JSON.stringify(jsonData);

    grid.appendChild(card);
    grid.appendChild(jsonScript);
  }

  function _interleaveGrid() {
    var grid = document.getElementById('pnb-product-grid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.pnb-card'));
    if (cards.length <= 1) return;

    var buckets = {};
    var order = [];
    cards.forEach(function (card) {
      var cats = (card.getAttribute('data-cats') || '').split(',').filter(Boolean);
      var primary = cats[0] || 'other';
      if (!buckets[primary]) { buckets[primary] = []; order.push(primary); }
      buckets[primary].push(card);
    });

    var interleaved = [];
    var active = true;
    while (active) {
      active = false;
      for (var i = 0; i < order.length; i++) {
        if (buckets[order[i]].length) {
          interleaved.push(buckets[order[i]].shift());
          active = true;
        }
      }
    }
    interleaved.forEach(function (card) { grid.appendChild(card); });
  }

  function loadRemainingProducts() {
    if (_ajaxStarted) return;
    var grid = document.getElementById('pnb-product-grid');
    if (!grid) return;
    var handle = grid.getAttribute('data-collection-handle');
    if (!handle) return;
    var root = grid.getAttribute('data-routes-root') || '/';
    if (root.slice(-1) !== '/') root += '/';
    _ajaxStarted = true;

    function fetchPage() {
      fetch(root + 'collections/' + handle + '/products.json?limit=' + _ajaxLimit + '&page=' + _ajaxPage)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          var products = data.products || [];
          products.forEach(_appendAjaxCard);
          if (products.length === _ajaxLimit) {
            _ajaxPage++;
            fetchPage();
          } else {
            _interleaveGrid();
            if (typeof applyGridLimit === 'function') applyGridLimit();
            if (typeof renderState === 'function') renderState();
          }
        })
        .catch(function () { /* silent fail — first 50 remain */ });
    }

    fetchPage();
  }

  // ------------------------------------------------------------------------
  // INIT
  // ------------------------------------------------------------------------
  function init() {
    // Mark this bundle as the active back-to-bundle target on page load,
    // so subsequent product-page visits in the same session show the tab.
    rememberBornBundleActive();

    // Fetch real Shopify cart, paint widget, then reconcile gift item if needed.
    cartFetch()
      .then(function () { renderState(); return syncGiftItem(); })
      .catch(function () { renderState(); });

    loadRemainingProducts();

    var root = document.querySelector('.pnb-bundle');
    if (root) {
      root.addEventListener('click', function (e) {
        handleAddClick(e);
        handleCardClick(e);
        handleBestsellerClick(e);
        handleChipClick(e);
        handleFaqClick(e);
        handleGiftOptionClick(e);
      });
    }

    var qvModal = document.getElementById('pnb-qv-modal');
    if (qvModal) qvModal.addEventListener('click', handleQVClick);

    // Rewards-panel CTA → take the customer to their real cart.
    var rewardsCta = document.getElementById('pnb-rewards-cta');
    if (rewardsCta) {
      rewardsCta.addEventListener('click', function () {
        var grid = document.getElementById('pnb-product-grid');
        var rt = (grid && grid.getAttribute('data-routes-root')) || '/';
        if (rt.slice(-1) !== '/') rt += '/';
        window.location.href = rt + 'cart';
      });
    }
    var rewardsToggle = document.getElementById('pnb-rewards-toggle');
    if (rewardsToggle) {
      rewardsToggle.addEventListener('click', function () {
        var p = document.getElementById('pnb-rewards-panel');
        if (p) p.classList.toggle('is-collapsed');
      });
    }

    var gridMoreBtn = document.getElementById('pnb-grid-more');
    if (gridMoreBtn) gridMoreBtn.addEventListener('click', handleGridMoreClick);

    applyGridLimit();
    ensureGiftSelection();

    var _resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(_resizeTimer);
      _resizeTimer = setTimeout(applyGridLimit, 150);
    });

    document.querySelectorAll('[data-scroll-to]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(el.getAttribute('data-scroll-to'));
        if (target) target.scrollIntoView({ behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });

    maybeShowBackPill();

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQuickView();
    });

    // Re-sync if the theme cart changes from elsewhere (drawer edits, etc.)
    document.addEventListener('cart:updated', function () { cartFetch().then(renderState).catch(function () {}); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.PnbBundle = { maybeShowBackPill: maybeShowBackPill };
})();
